import { FormikHelpers } from "formik";
import { useCreatePendingStatus } from "./api/createPendingStatus";
import PendingStatusForm from "./PendingStatusForm";


const CreatePendingStatus = ({handleCloseModal}: CreatePendingStatusProps)  => {
  const createPendingStatusMutation = useCreatePendingStatus({data: {}});

  const initialValues: IPostNewPendingStatus = {
    description: "",
    deleted: false
  };

  const handleSubmit = async (values: IPostNewPendingStatus, { setSubmitting }: FormikHelpers<IPostNewPendingStatus>): Promise<void> => {
    try {
      await createPendingStatusMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <PendingStatusForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreatePendingStatusProps {
  handleCloseModal: () => void;
}

export default CreatePendingStatus;